// This enum contains the type of event lockings managed by the web client app 
export enum LockingTypes {
   none,
   day,
   dayAndTime
}
